﻿import { ensureBootstrap } from "@js/core/loaders/vendors";
import { initLazySizes } from "@js/components/common/lazysizes";
import { initFancybox } from "@js/components/common/fancybox";
import { initWowAnimations } from "@js/components/common/wow";
import { initProductsSwiper, initEventsSwiper } from "@js/components/common/swipers";
import { initCountUpCounters } from "@js/components/common/counters";
import { initCookieConsent } from "@js/components/common/cookie-consent";
import { initHeaderState } from "@js/components/layout/header-state";
import { initTabs } from "@js/components/common/tabs";
import { initLegacyGlobals } from "@js/components/common/site-legacy";

function initWhenNearViewport(selector, initializer) {
    const element = document.querySelector(selector);
    if (!element) return;

    if (!("IntersectionObserver" in window)) {
        void initializer();
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        if (!entries.some(entry => entry.isIntersecting)) return;

        observer.disconnect();
        void initializer();
    }, { rootMargin: "320px 0px" });

    observer.observe(element);
}

export async function initSiteBootstrap() {
    await ensureBootstrap();

    initLegacyGlobals();
    initHeaderState();
    initCookieConsent();
    initTabs();

    void initLazySizes();
    initWhenNearViewport("[data-fancybox]", initFancybox);
    initWhenNearViewport(".wow", initWowAnimations);
    initWhenNearViewport(".swiper--products", initProductsSwiper);
    initWhenNearViewport(".swiper--events", initEventsSwiper);
    initWhenNearViewport(".num", initCountUpCounters);
}
